import { utilityColors } from 'ui/theme/colors';
import { NegativeFill, WarningFill } from 'ui/icons';
import { ErrorThemeDisplay } from './types';

export enum ERROR_TYPES {
  CONTENT_ERROR = 'contentError',
  CONTENT_WARNING = 'contentWarning',
}

export const errorThemes: Record<ERROR_TYPES, ErrorThemeDisplay> = {
  [ERROR_TYPES.CONTENT_ERROR]: {
    errorColor: utilityColors.negative100,
    Icon: NegativeFill,
    errorMessage: 'Invalid content',
  },
  [ERROR_TYPES.CONTENT_WARNING]: {
    errorColor: utilityColors.warning100,
    Icon: WarningFill,
    errorMessage: 'Required before sending campaign',
  },
};
